import { Badge } from "@/components/ui/badge";
import { Tag, Wallet } from "lucide-react";

const eur = (v) => `€${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 4 })}`;

export const DiscountBadge = ({ d, testId }) => d ? (
  <Badge variant="outline" className="bg-accent/15 text-accent border-accent/30 text-[10px] gap-1 whitespace-nowrap" title={d.label || "Codice sconto utilizzato"} data-testid={testId}>
    <Tag className="h-3 w-3" />{d.code}{d.off ? ` ${d.off}` : ""}
  </Badge>
) : <span className="text-muted-foreground text-xs" data-testid={testId}>Nessuno</span>;

const Cell = ({ label, value, testId, cls = "" }) => (
  <div className="rounded-lg bg-background/60 p-2">
    <div className="text-[11px] text-muted-foreground">{label}</div>
    <div className={`font-mono-data font-semibold ${cls}`} data-testid={testId}>{value}</div>
  </div>
);

export const UserBillingCard = ({ billing: b, discount: d }) => {
  if (!b) return null;
  const pos = b.margin_month_eur >= 0;
  return (
    <div className="rounded-xl bg-secondary/50 p-3 space-y-3" data-testid="user-billing-card">
      <div className="flex items-center justify-between gap-2">
        <div className="font-medium flex items-center gap-2"><Wallet className="h-4 w-4 text-primary" /> Costi e ricavi</div>
        {b.source && <Badge variant="outline" className="text-[10px]" data-testid="billing-source">{b.source}{b.yearly ? " · annuale" : ""}</Badge>}
      </div>
      <div className="grid grid-cols-2 gap-2">
        <Cell label={b.yearly ? "Paga al mese (annuale / 12)" : "Paga al mese"} value={eur(b.paid_month_eur)} testId="billing-paid-month" />
        <Cell label="Costo questo mese" value={eur(b.cost_month_eur)} testId="billing-cost-month" />
        <Cell label="Margine questo mese" value={`${pos ? "+" : ""}${eur(b.margin_month_eur)}`} testId="billing-margin-month" cls={pos ? "text-primary" : "text-destructive"} />
        <Cell label="Costo totale storico" value={eur(b.cost_total_eur)} testId="billing-cost-total" />
      </div>
      <div className="flex items-center justify-between gap-2 text-xs">
        <span className="text-muted-foreground">Codice sconto</span>
        <span className="flex items-center gap-2 flex-wrap justify-end">
          <DiscountBadge d={d} testId="detail-discount-badge" />
          {d && <span className="text-muted-foreground" data-testid="detail-discount-info">
            {d.personal ? "personale" : "generale"}{d.duration ? ` · ${d.duration === "forever" ? "su ogni rinnovo" : "solo primo pagamento"}` : ""}
            {d.used_at ? ` · usato il ${new Date(d.used_at).toLocaleDateString("it-IT")}` : ""}
          </span>}
        </span>
      </div>
      {b.note && <p className="text-[11px] text-muted-foreground" data-testid="billing-note">{b.note}</p>}
      <p className="text-[11px] text-muted-foreground">Costo = consumi variabili (DietFlix ed email) attribuiti all'utente, esclusi i costi fissi della piattaforma.</p>
    </div>
  );
};
